(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GpfsBatchDeleteController',GpfsBatchDeleteController);

    GpfsBatchDeleteController.$inject = ['$uibModalInstance', 'entity', 'GpfsBatch'];

    function GpfsBatchDeleteController($uibModalInstance, entity, GpfsBatch) {
        var vm = this;

        vm.gpfsBatch = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GpfsBatch.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
